/*
 * Module for the basic KB settings
 */

define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "modules/accountAdmin/kbProfile/kbSettings/kbSettingsView",
  "modules/accountAdmin/kbWizardModal/kbWizardModalModule",
  "modules/accountAdmin/kbAdmin/kbModel",
], function (Backbone, Marionette, Messenger, KbSettingsView, KbWizardModalModule, KbModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbSettings";
      this.region = options.region;
      this.kb = options.model;
      this.secretKey = options.secretKey;
      this.kb.secretKey = this.secretKey;
      this._setUpVents();
    },
    show: function () {
      this.kb.hidePcasPassword = true;
      this.kb.engineModes = Messenger.reqres.request("kb:engine:modes");
      this.kb.hideSecretKey = true;
      if (this.secretKey) {
        this.kb.maskedSecretKey = this._maskField(this.secretKey.get("secretKey"));
        //this.kb is updated when refresh:kb:profile is triggered by kbWizardModalModule, so secretKey is lost
        this.kb.secretKey = this.secretKey;
      }

      Messenger.onSave(function () {
        Messenger.saveAttempted(true); //success
      }, this);

      this.layout = new KbSettingsView.kbSettingsLayout({ model: this.kb });

      if (!this.readonly) {
        this.layout.on(
          "togglePcasPassword",
          function () {
            this.kb.hidePcasPassword = !this.kb.hidePcasPassword;
            this.layout.render();
          },
          this,
        );

        this.layout.on(
          "toggleSecretKey",
          function () {
            this.kb.hideSecretKey = !this.kb.hideSecretKey;
            this.layout.render();
          },
          this,
        );

        this.layout.on(
          "editSettings",
          function () {
            const modalBundle = {
              kbStep: "settings",
              item: this.kb,
            };
            Messenger.vent.trigger(
              "show:modal",
              KbWizardModalModule,
              {
                editMode: true,
              },
              modalBundle,
              {
                title: "admin.kbAdmin.editKb",
                closeOnBackgroundClick: false,
                modalWidth: 1000,
                trackInteraction: {
                  action: "Edit Knowledge Base",
                  id: this.kb.id,
                  idType: "Knowledge Base",
                  object: "Knowledge Base",
                },
              },
            );
          },
          this,
        );

        this.layout.on(
          "editAgentAssist",
          function () {
            const modalBundle = {
              kbStep: "agentAssist",
              item: this.kb,
            };
            Messenger.vent.trigger(
              "show:modal",
              KbWizardModalModule,
              {
                editMode: true,
              },
              modalBundle,
              {
                title: "admin.kbAdmin.editKb",
                closeOnBackgroundClick: false,
                modalWidth: 1000,
                trackInteraction: {
                  action: "Edit Knowledge Base",
                  id: this.kb.id,
                  idType: "Knowledge Base",
                  object: "Knowledge Base",
                },
              },
            );
          },
          this,
        );

        this.layout.on("removeKb", () => Messenger.vent.trigger("remove:kb", this.kb));
      }

      // If this KB belongs to a landlord, then hide any features not enabled for the landlord
      this.tenant = Messenger.reqres.request("fetch:tenant", this.kb.get("tenantId"));
      if (this.tenant.get("landlordId") !== 0) {
        this.kb.landlord = Messenger.reqres.request(
          "fetch:landlord",
          this.tenant.get("landlordId"),
        );
        this.kb.landlord.onSynced(function () {
          if (this.kb.landlord.get("agentAssist").enabled && this.kb.get("agentAssist")) {
            this.kb.maskedPcasPassword = this._maskField(this.kb.get("pcasPassword"));
          }
          this.layout.model = this.kb;
          this.layout.render();
        }, this);
      } else {
        //This KB doesn't belong to a landlord, so show all features enabled for the KB
        if (this.kb.get("agentAssist")) {
          this.kb.maskedPcasPassword = this._maskField(this.kb.get("pcasPassword"));
        }
        this.layout.model = this.kb;
        this.layout.render();
      }

      this.showRegion(this.layout);
    },
    _maskField: function (field) {
      return field.replace(/./g, "*");
    },
    _setUpVents: function () {
      //Show the KB settings screen
      Messenger.vent.on(
        "show:kb:profile:kbSettings",
        function () {
          //fetch secret key if a new KB was added and display as masked key to the user
          this.kbSecretKeys = Messenger.reqres.request("kbSecretKeys");
          this.kbSecretKeys.onSynced(function () {
            this.secretKey = this.kbSecretKeys.findWhere({ kbId: this.kb.get("kbId") });
            this.show();
          }, this);
        },
        this,
      );

      Messenger.vent.on(
        "refresh:kb:profile",
        function (updatedKb) {
          this.kb = updatedKb;
          this.show();
        },
        this,
      );
    },
  });
});
